"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UserVersion = 1;
exports.UserEventCategory = "User";
exports.UserCommandCategory = "User";
//# sourceMappingURL=UserDefinition.js.map